"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateVector2 = void 0;
/**
 * Rotates the x/y values to a given angle.
 */
function rotateVector2(x, y, radians) {
    var cos = Math.cos(radians);
    var sin = Math.sin(radians);
    return {
        x: x * cos - y * sin,
        y: x * sin + y * cos
    };
}
exports.rotateVector2 = rotateVector2;
//# sourceMappingURL=rotateVector2.js.map